import appConfig from './appConfig'

export const getEnvironment = (hostname: string) => {
  const domainMatches = appConfig && Object.keys(appConfig).filter((env) => hostname.includes(appConfig[env].ENV_KEY))
  return domainMatches.length === 0 ? 'production' : domainMatches.length === 1 ? domainMatches[0] : 'development'
}
